import { ClaimIssueSelectionKind } from '@portal/schema';

export const CLAIM_ISSUE_SELECTION_KIND_TO_NAME: { [key in ClaimIssueSelectionKind]: string } = {
  [ClaimIssueSelectionKind.Billing]: 'Billing issue',
  [ClaimIssueSelectionKind.Appointment]: 'Appointment issue',
  [ClaimIssueSelectionKind.Other]: 'Other issue',
};

export const CLAIM_ISSUE_SELECTION_NAME_PLACEHOLDER = '-';
